var V=Object.defineProperty;var X=(x)=>x;function Z(x,f){this[x]=X.bind(null,f)}var S=(x,f)=>{for(var j in f)V(x,j,{get:f[j],enumerable:!0,configurable:!0,set:Z.bind(f,j)})};import{mkdirSync as $}from"node:fs";import{createRequire as H}from"node:module";import{dirname as W}from"node:path";function J(x){if(x instanceof Error)return x.message;return String(x)}function K(x){if(x&&typeof x==="object"&&"code"in x&&typeof x.code==="string")return x.code;return""}var G=3,U=50;function D(){return new Date().toISOString()}function Q(x){return x?1:0}function I(x){return typeof x==="string"?x:""}function N(x){if(typeof x!=="string")return;let f=x.trim();return f.length>0?f:void 0}function A(x){return x===1||x===!0}function L(x){if(x<=0)return;try{let f=new SharedArrayBuffer(4),j=new Int32Array(f);Atomics.wait(j,0,0,x)}catch{}}function M(x){if(!x||typeof x!=="object")return!1;let f=J(x),j=K(x);return j==="SQLITE_BUSY"||j==="SQLITE_LOCKED"||f.includes("SQLITE_BUSY")||f.includes("SQLITE_LOCKED")||f.includes("database is locked")}function z(x){let f=0;for(;;)try{return x()}catch(j){if(!M(j)||f>=G)throw j;f+=1,L(U*2**(f-1))}}function P(x){return{prepare:(f)=>{let j=x.query(f);return{run:(...k)=>z(()=>j.run(...k)),get:(...k)=>z(()=>j.get(...k)),all:(...k)=>z(()=>j.all(...k))}},exec:(f)=>z(()=>x.exec(f)),close:()=>x.close?.()}}function Y(x){return{prepare:(f)=>{let j=x.prepare(f);return{run:(...k)=>z(()=>j.run(...k)),get:(...k)=>z(()=>j.get(...k)??null),all:(...k)=>z(()=>j.all(...k))}},exec:(f)=>z(()=>x.exec(f)),close:()=>x.close?.()}}function C(x){$(W(x),{recursive:!0});let f=H(import.meta.url);if(typeof globalThis.Bun<"u"){let{Database:k}=f("bun:sqlite");return P(new k(x,{create:!0}))}let j=process.emitWarning;process.emitWarning=(k,...O)=>{if((typeof k==="string"?k:k?.message??"").includes("SQLite"))return;return j.call(process,k,...O)};try{let{DatabaseSync:k}=f(["node",":sqlite"].join(""));return Y(new k(x))}finally{process.emitWarning=j}}var c=[`CREATE TABLE IF NOT EXISTS sessions (
		session_id TEXT PRIMARY KEY,
		source TEXT NOT NULL,
		pid INTEGER NOT NULL,
		started_at TEXT NOT NULL,
		ended_at TEXT,
		exit_code INTEGER,
		status TEXT NOT NULL,
		status_lock INTEGER NOT NULL DEFAULT 0,
		interactive INTEGER NOT NULL,
		provider TEXT NOT NULL,
		model TEXT NOT NULL,
		cwd TEXT NOT NULL,
		workspace_root TEXT NOT NULL,
		team_name TEXT,
		enable_tools INTEGER NOT NULL,
		enable_spawn INTEGER NOT NULL,
		enable_teams INTEGER NOT NULL,
		parent_session_id TEXT,
		parent_agent_id TEXT,
		agent_id TEXT,
		conversation_id TEXT,
		is_subagent INTEGER NOT NULL DEFAULT 0,
		prompt TEXT,
		metadata_json TEXT,
		transcript_path TEXT NOT NULL DEFAULT '',
		hook_path TEXT NOT NULL,
		messages_path TEXT,
		updated_at TEXT NOT NULL
	);`,`CREATE TABLE IF NOT EXISTS subagent_spawn_queue (
		id INTEGER PRIMARY KEY AUTOINCREMENT,
		root_session_id TEXT NOT NULL,
		parent_agent_id TEXT NOT NULL,
		task TEXT,
		system_prompt TEXT,
		created_at TEXT NOT NULL,
		consumed_at TEXT
	);`,`CREATE TABLE IF NOT EXISTS schedules (
		schedule_id TEXT PRIMARY KEY,
		name TEXT NOT NULL,
		cron_pattern TEXT NOT NULL,
		prompt TEXT NOT NULL,
		provider TEXT NOT NULL,
		model TEXT NOT NULL,
		mode TEXT NOT NULL DEFAULT 'act',
		workspace_root TEXT,
		cwd TEXT,
		system_prompt TEXT,
		max_iterations INTEGER,
		timeout_seconds INTEGER,
		max_parallel INTEGER NOT NULL DEFAULT 1,
		enabled INTEGER NOT NULL DEFAULT 1,
		created_at TEXT NOT NULL,
		updated_at TEXT NOT NULL,
		last_run_at TEXT,
		next_run_at TEXT,
		claim_token TEXT,
		claim_started_at TEXT,
		claim_until_at TEXT,
		created_by TEXT,
		tags TEXT,
		metadata_json TEXT
	);`,`CREATE TABLE IF NOT EXISTS schedule_executions (
		execution_id TEXT PRIMARY KEY,
		schedule_id TEXT NOT NULL,
		session_id TEXT,
		triggered_at TEXT NOT NULL,
		started_at TEXT,
		ended_at TEXT,
		status TEXT NOT NULL,
		exit_code INTEGER,
		error_message TEXT,
		iterations INTEGER,
		tokens_used INTEGER,
		cost_usd REAL,
		FOREIGN KEY (schedule_id) REFERENCES schedules(schedule_id) ON DELETE CASCADE,
		FOREIGN KEY (session_id) REFERENCES sessions(session_id) ON DELETE SET NULL
	);`,`CREATE INDEX IF NOT EXISTS idx_schedule_executions_schedule
	ON schedule_executions(schedule_id, triggered_at DESC);`,`CREATE INDEX IF NOT EXISTS idx_schedules_next_run
	ON schedules(enabled, next_run_at);`],T=[{table:"sessions",column:"workspace_root",sql:"ALTER TABLE sessions ADD COLUMN workspace_root TEXT;"},{table:"sessions",column:"parent_session_id",sql:"ALTER TABLE sessions ADD COLUMN parent_session_id TEXT;"},{table:"sessions",column:"parent_agent_id",sql:"ALTER TABLE sessions ADD COLUMN parent_agent_id TEXT;"},{table:"sessions",column:"agent_id",sql:"ALTER TABLE sessions ADD COLUMN agent_id TEXT;"},{table:"sessions",column:"conversation_id",sql:"ALTER TABLE sessions ADD COLUMN conversation_id TEXT;"},{table:"sessions",column:"is_subagent",sql:"ALTER TABLE sessions ADD COLUMN is_subagent INTEGER NOT NULL DEFAULT 0;"},{table:"sessions",column:"messages_path",sql:"ALTER TABLE sessions ADD COLUMN messages_path TEXT;"},{table:"sessions",column:"metadata_json",sql:"ALTER TABLE sessions ADD COLUMN metadata_json TEXT;"},{table:"sessions",column:"transcript_path",sql:"ALTER TABLE sessions ADD COLUMN transcript_path TEXT NOT NULL DEFAULT '';"},{table:"schedules",column:"claim_token",sql:"ALTER TABLE schedules ADD COLUMN claim_token TEXT;"},{table:"schedules",column:"claim_started_at",sql:"ALTER TABLE schedules ADD COLUMN claim_started_at TEXT;"},{table:"schedules",column:"claim_until_at",sql:"ALTER TABLE schedules ADD COLUMN claim_until_at TEXT;"}];function _(x,f){return new Set(x.prepare(`PRAGMA table_info(${f});`).all().map((j)=>j.name))}function B(x,f={}){x.exec("PRAGMA journal_mode = WAL;"),x.exec("PRAGMA busy_timeout = 5000;");for(let O of c)x.exec(O);if(!f.includeLegacyMigrations)return;let j=new Map,k=(O)=>{let F=j.get(O);if(!F)F=_(x,O),j.set(O,F);return F};for(let O of T)if(!k(O.table).has(O.column)){if(x.exec(O.sql),O.column==="workspace_root")x.exec("UPDATE sessions SET workspace_root = cwd WHERE workspace_root IS NULL OR workspace_root = '';");j.delete(O.table)}}export{Q as toBoolInt,D as nowIso,C as loadSqliteDb,B as ensureSessionSchema,I as asString,N as asOptionalString,A as asBool};
